import { Component } from "react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export default class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep diagnostics available to developers without exposing stack traces in the UI.
    console.error("Route render failed", error, info);
  }

  reset = () => {
    this.setState({ hasError: false });
  };

  reload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-[60vh] items-center justify-center p-6">
        <Card className="max-w-lg rounded-xl border-slate-200 p-8 text-center shadow-sm">
          <h1 className="text-xl font-semibold text-slate-900">Something went wrong.</h1>
          <p className="mt-3 text-sm text-slate-600">
            Refresh this page or go back to Dashboard.
          </p>
          <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <Button onClick={this.reload} className="bg-[#0F2A47] hover:bg-[#14385E] text-white">
              Reload page
            </Button>
            <Button asChild variant="outline" onClick={this.reset}>
              <Link to="/dashboard">Back to Dashboard</Link>
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}
